import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { exhaustiveGuard } from "@pathwright/ux/src/utils/typing"
import { TFunction } from "i18next"
import { ResourceFragment, ResourceType } from "@pathwright/graphql-client/src/generated"
import { ResourceTypeSchema } from "./constants"

// NOTE: this may exist in the translation-extractor branch, just needing it now
export const getResourceTypeLabel = (
  resourceType: ResourceType | number,
  translator: TFunction
) => {
  const resourceTypeEnum =
    typeof resourceType === "number"
      ? ResourceTypeSchema.parse(resourceType)
      : resourceType

  switch (resourceTypeEnum) {
    case ResourceType.Course:
      return translator(`resource.types.course`)
    case ResourceType.Lesson:
      return translator(`resource.types.lesson`)
    case ResourceType.Collection:
      return translator(`resource.types.collection`)
    default:
      return exhaustiveGuard(resourceTypeEnum)
  }
}

export const useTranslatedResourceTypeLabel = (
  resource: ResourceFragment | null
) => {
  const { t } = useTranslate()

  if (!resource) return ""

  return getResourceTypeLabel(resource.resource_type, t)
}

export const withTranslatedResourceTypeLabel =
  <T extends { resource: ResourceFragment | null }>(
    Component: React.ComponentType<{ resourceTypeLabel: string } & T>
  ) =>
  (props: T) => {
    const resourceTypeLabel = useTranslatedResourceTypeLabel(props.resource)
    return <Component {...props} resourceTypeLabel={resourceTypeLabel} />
  }

export const getRandomResourceCover = () => {
  const n = Math.ceil(Math.random() * 72)
  return `https://pathwright-static-media.s3.amazonaws.com/default-image-set-v1/cover-image-${n}.png`
}
